const API_BASE_URL =
  "https://usefullsofware.com/visioner7_api_services/v1/dxn/";

export const eventoService = {
  async listarEventos() {
    try {
      const token = localStorage.getItem("auth_token");

      if (!token) {
        return {
          success: false,
          error: "No hay sesión activa. Por favor, inicie sesión nuevamente.",
          code: 401,
        };
      }

      const response = await fetch(`${API_BASE_URL}productos/eventos_listar.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ token }),
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          return {
            success: false,
            error: "Sesión expirada o permisos insuficientes.",
            code: response.status,
          };
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (data.server_mensaje && data.server_mensaje.ESTADO === 1) {
        return {
          success: true,
          data: data.data || [],
          mensaje: data.server_mensaje.MENSAJE,
        };
      } else {
        return {
          success: false,
          error:
            data.server_mensaje?.MENSAJE || "Error al obtener los eventos.",
          code: 400,
        };
      }
    } catch (error) {
      console.error("Error en eventoService.listarEventos:", error);
      return {
        success: false,
        error: "Error de conexión con el servidor. Intente nuevamente.",
        code: 500,
      };
    }
  },

  async registrarEvento(datosEvento) {
    try {
      const token = localStorage.getItem("auth_token");

      if (!token) {
        return { success: false, error: "No hay sesión activa.", code: 401 };
      }

      const payload = {
        token,
        ...datosEvento,
      };

      const response = await fetch(`${API_BASE_URL}productos/eventos_register.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          return {
            success: false,
            error: "Sesión expirada o no tienes permisos de administrador.",
            code: response.status,
          };
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (data.server_mensaje && data.server_mensaje.ESTADO === 1) {
        return { success: true, mensaje: data.server_mensaje.MENSAJE, data: data.data };
      } else {
        return {
          success: false,
          error:
            data.server_mensaje?.MENSAJE || "Error al registrar el evento.",
        };
      }
    } catch (error) {
      console.error("Error en eventoService.registrarEvento:", error);
      return {
        success: false,
        error: "Error de conexión al registrar el evento.",
      };
    }
  },

  async editarEvento(id_evento, datosActualizados) {
    try {
      const token = localStorage.getItem("auth_token");

      if (!token) {
        return { success: false, error: "No hay sesión activa.", code: 401 };
      }

      const payload = {
        token,
        id_evento: parseInt(id_evento),
        ...datosActualizados,
      };

      const response = await fetch(`${API_BASE_URL}productos/eventos_editar.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          return {
            success: false,
            error: "Sesión expirada o no tienes permisos de administrador.",
            code: response.status,
          };
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (data.server_mensaje && data.server_mensaje.ESTADO === 1) {
        return { success: true, mensaje: data.server_mensaje.MENSAJE };
      } else {
        return {
          success: false,
          error:
            data.server_mensaje?.MENSAJE || "Error al actualizar el evento.",
        };
      }
    } catch (error) {
      console.error("Error en eventoService.editarEvento:", error);
      return {
        success: false,
        error: "Error de conexión al guardar los cambios.",
      };
    }
  },
};